module.exports = __webpack_public_path__ + "static/media/03.6f542aa3.jpg";